const cookies = require("../cookies/cookies.js");
const slickSliderHelper = require('../slickSlider/slickSliderHelper.js');

// initialize to global scope so favorites module can communicate with favorites modules in separate .js files
window.favoritesEventBus = window.favoritesEventBus || require("../eventBus/eventBus.js");

module.exports = (function () {
    /**
     * @method set
     * @description Adds the vacation to the favorites
     * @param {string} id - The Umbraco guid if it's a tour and the cruise id (url) if it's a cruise
     */
    let addToFavorites = function (id) {
        if (id) {
            let favorites = getFavoritesFromCookie(); // Retrieve the favorites from the cookie
            if (!favorites) {
                favorites = [];
            }
            favorites.push(id); // Add the tourId to the favorites array
            saveFavoritesToCookie(favorites); // Save the updated favorites to the cookie
            window.favoritesEventBus.$emit("favoriteUpdated", favorites, { action: 'add', value: id });
        }
    };

    /**
     * @method removeFavorites
     * @description Removes the vacation from the favorites
     * @param {string} id - The Umbraco guid if it's a tour and the cruise id (url) if it's a cruise
     */
    let removeFromFavorites = function (id) {
        const favorites = getFavoritesFromCookie(); // Retrieve the favorites from the cookie
        const index = favorites.indexOf(id);
        if (index !== -1) {
            favorites.splice(index, 1); // Remove the tourId from the favorites array
            saveFavoritesToCookie(favorites); // Save the updated favorites to the cookie
            window.favoritesEventBus.$emit("favoriteUpdated", favorites, { action: 'remove', index: index });
        }
    };

    /**
     * @method toggleFavorite
     * @description Toggles an item into and out of the favorites list. Note that this does not visually update button states
     * @param {string} id - The Umbraco guid if it's a tour and the cruise id (url) if it's a cruise
     */
    let toggleFavorite = function (id) {
        if (!isFavorite(id)) {
            addToFavorites(id);
        } else {
            removeFromFavorites(id)
        }
    }

    /**
     * @method getFavorites
     * @description Gets the list of favorites from the cookie
     */
    let getFavoritesFromCookie = function () {
        var favCookie = cookies.get("get-favorites");
        if (favCookie) {
            return decodeURIComponent(favCookie).split(",");
        }
    };

    /**
     * @method saveFavoritesToCookie
     * @description Saves the favorites to the cookie
     * @param {string[]} favorites - The list of Ids that will be combined to store in the cookie
     */
    let saveFavoritesToCookie = function (favorites) {
        if (favorites) {
            const favoriteString = favorites.join(",");
            cookies.set("get-favorites", encodeURIComponent(favoriteString), 90);
        }
    };

    /**
     * @method isFavorite
     * @description Checks to see if the vacation is a favorite
     * @param {string} id - The Umbraco guid if it's a tour and the cruise id (url) if it's a cruise
     * @returns {boolean} - If the favorite exists in the cookie or not
     */
    let isFavorite = function (id) {
        if (id) {
            const favorites = getFavoritesFromCookie(); // Retrieve the favorites from the cookie
            if (!favorites) {
                return false;
            }
            return favorites.includes(id); // Check if the tourId exists in the favorites array
        }
    };

    /**
     * @method setFavoriteIcons
     * @description Updates all of the like buttons on the page when an item is liked or unliked
     */
    let setFavoriteIcons = function () {
        $('[data-favorite]').each(function () {
            const $this = $(this);
            const favId = $this.data('favorite');
            if (favId) {
                if (isFavorite(favId)) {
                    $this.addClass('btn-liked');
                } else {
                    $this.removeClass('btn-liked');
                }
            }
        });
    };

    /**
     * @method initializeFavoriteButtons
     * @description Initializes favorite button behavior
     * @param {string} selector - css selector to target the favorite buttons to initialize
     */
    let initializeFavoriteButtons = function(selector) {
        $(selector).click(function () {
            const $this = $(this);
            const favId = $this.data('favorite');
            toggleFavorite(favId);
            setFavoriteIcons();
        });
    }

    // -------------------- VUE IS HERE ------------------------------------

    /**
     * @method renderFavoritesList
     * @description Initialize the dynamic wishlist component
     * @param {string} elementId - id used to target the html wrapper element for this vue.js component
     */
    let renderFavoritesList = function (elementId) {
        let favoriteTimerId = 0;
        new Vue({
            el: "#" + elementId,
            data() {
                return {
                    favoriteTours: [],
                    sliderSelector: '#' + elementId + ' .mobile-tmc-slider'
                };
            },
            created() {
                if (!this.favoriteTours || this.favoriteTours.length == 0) {
                    var ids = getFavoritesFromCookie();
                    this.updateFavoriteTours(ids);
                }
                window.favoritesEventBus.$on("favoriteUpdated", (ids, actionData) => {
                    this.updateFavoriteTours(ids, actionData);
                });
            },
            updated() {

            },
            methods: {
                removeFavorite(favId) {
                    removeFromFavorites(favId);
                    setFavoriteIcons();
                },
                reinitializeSlider() {
                    // Must give vue.js a chance to finish what its up to before slick kicks in
                    if (typeof favoriteTimerId === "number" && favoriteTimerId > 0) {
                        clearTimeout(favoriteTimerId);
                    }
                    favoriteTimerId = setTimeout(() => {
                        let $slider = $(this.sliderSelector);
                        let isInitialized = $slider.hasClass('slick-initialized');
                        if (isInitialized) {
                            $(this.sliderSelector).slick('unslick');
                        } else {


                            this.initializeSlider();
                        }
                    }, 2000);
                },
                initializeSlider() {
                    if (this.favoriteTours && this.favoriteTours.length > 0) {
                        slickSliderHelper.initialize(this.sliderSelector, {
                            infinite: false,
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            responsive: [
                                {
                                    breakpoint: 1199,
                                    settings: "unslick-above"
                                },
                                {
                                    breakpoint: 991,
                                    settings: {
                                        slidesToShow: 2,
                                    }
                                },
                                {
                                    breakpoint: 599,
                                    settings: {
                                        slidesToShow: 1,
                                }
                                }
                            ]
                        });
                    }
                    
                },
                removeSliderItem(idx) {
                    $(this.sliderSelector).slick('slickRemove', idx);
                },
                async updateFavoriteTours(ids, actionData) {
                    try {
                        const response = await fetch(
                            "/umbraco/api/FavoritesApi/GetFavoriteTours?ids=" + ids,
                            {
                                method: "GET",
                                headers: {
                                    "Content-Type": "application/json",
                                }
                            }
                        );
                        if (response.ok) {
                            const data = await response.json();
                            this.favoriteTours = data;
                            if (actionData && actionData.action === 'remove' && actionData.index) {
                                this.removeSliderItem(actionData.index);
                            } else {
                                this.reinitializeSlider();
                            }
                        } else {
                            throw new Error("Failed to fetch favorite tours");
                        }
                    } catch (error) {
                        console.error("Failed to fetch favorite tours:", error);
                    }
                }
            }
        });
    };

    return {
        setFavoriteIcons: setFavoriteIcons,
        addToFavorites: addToFavorites,
        removeFromFavorites: removeFromFavorites,
        isFavorite: isFavorite,
        renderFavoritesList: renderFavoritesList,
        toggleFavorite: toggleFavorite,
        initializeFavoriteButtons: initializeFavoriteButtons
    };
})();
